import React from 'react';
import { connect } from 'react-redux';

import {filterByPermission} from "../../../../Components/Can";
import DashboardLayout from "../../../Layout/DashboardLayout";
import urls from "../../../../../Utils/URLs";


function OperationsLayout(props) {
    const allowedUsers = [
        'jgranada@simpliworks.io',// 1422,  Jessamie Joy
        'msiblag@simpliworks.io',//1453,  MARC
        'ygarcia@simpliworks.io',//1520,  Yam
        'smason@simpliworks.io',//1688,  Shelby
        'malik@simpliworks.io',//1233,  Malik
        'access@simpliworks.io',//129    Access
        'devteam@simpliworks.io' // 2776 dev team
    ];


    let menuItems = [
        // {
        //     perform: "ops:dataCollection",
        //     yes: {
        //         icon: 'pe-7s-server',
        //         label: 'Data Collection',
        //         to: urls.OPS_DATA_COLLECTION_URL,
        //     }
        // },
        
        // {
        //     perform: "ops:productEnrollment",
        //     yes: {
        //         icon: 'pe-7s-notebook',
        //         label: 'Product Enrollment',
        //         to: urls.OPS_PRODUCT_ENROLLMENT_URL,
        //     }
        // },
        // {
        //     perform: "ops:productBudgetUpdate",
        //     yes: {
        //         icon: 'pe-7s-cash',
        //         label: 'Product Budget Update',
        //         to: urls.OPS_PRODUCT_BUDGET_UPDATE_URL,
        //     }
        // },
        // {
        //     perform: "ops:userAuthorization",
        //     yes: {
        //         icon: 'pe-7s-users',
        //         label: 'User Authorization',
        //         to: urls.OPS_USER_AUTHORIZATION_URL,
        //     }
        // },
        // {
        //     perform: "ops:sellerPartnerData",
        //     yes: {
        //         icon: 'pe-7s-display2',
        //         label: 'Seller Partner Data',
        //         to: urls.OPS_SELLER_PARTNER_DATA_URL,
        //     }
        // },
        // {
        //     perform: "ops:advertisingData",
        //     yes: {
        //         icon: 'pe-7s-display2',
        //         label: 'Advertising Reports Data',
        //         to: urls.OPS_ADVERTISING_DATA_URL,
        //     }
        // },
        {
            perform: "ops:advertisingJob",
            yes: {
                icon: 'pe-7s-cash',
                label: 'Advertising API Jobs',
                to: urls.OPS_ADVERTISING_JOB_URL,
            }
        },
        {
            perform: "ops:campaignLaunch",
            yes: {
                icon: 'pe-7s-rocket',
                label: 'Campaign Launch',
                to: urls.OPS_CAMPAIGN_LAUNCH_URL,
            }
        },
        {
            perform: 'ops:workflows',
            yes: {
                icon: 'pe-7s-notebook',
                label: 'Workflows',
                content: [
                    {
                        icon: 'pe-7s-home',
                        label: 'Store Kick Off',
                        to: urls.OPS_WF_STORE_KICKOFF_URL,
                    },
                    {
                        icon: 'pe-7s-note2',
                        label: 'WF Tasks Dashboard',
                        to: urls.OPS_WF_TASKS_DASHBOARD_URL,
                    },
                    ...(allowedUsers.includes(props.currentLoggedUser.user.email)
                    ? [{
                        icon: 'pe-7s-users',
                        label: 'Task Role Assignment',
                        to: urls.OPS_WF_TASK_ROLE_ASSIGNMENT_URL,
                    }]
                    : [])
            ],
               
            }
        },
        // {
        //     perform: 'ops:ticketList',
        //     yes: {
        //         icon: 'pe-7s-display2',
        //         label: 'Ticket List',
        //         to: urls.OPS_TICKETLIST_URL,
        //     }
        // },
        {
            perform: 'ops:storeHealth',
            yes: {
                icon: 'pe-7s-display2',
                label: 'Store Health',
                to: urls. OPS_STOREHEALTH_URL,
            }
        },
        // {
        //     perform: 'ops:proactiveMonitoring',
        //     yes: {
        //         icon: 'pe-7s-display2',
        //         label: 'Proactive Monitoring',
        //         to: urls. OPS_PROACTIVE_MONITORING,
        //     }
        // },
        {
            perform: 'ops:resourceSkillSet',
            yes: {
                icon: 'pe-7s-plugin',
                label: 'Resource Skill Set',
                to: urls.OPS_RESOURCESKILLSET_URL,
            }
        },
        {
            perform: 'ops:ticketAssign',
            yes: {
                icon:'pe-7s-note2',
                label: 'Ticket Assignment',
                to: urls.OPS_TICKETASSIGN_URL,
            }
        },
        {
            perform: 'ops:account',
            yes: {
                icon: 'pe-7s-users',
                label: 'Accounts',
                to: urls.OPS_ACCOUNTS_URL,
            }
        },

    ];

    menuItems = filterByPermission(menuItems, props.accessLevel);

    return (
        <DashboardLayout
            menuItems={menuItems}
            loggedUser={props.loggedUser}
            heading="Operations Monitoring"
            icon="lnr-map text-info"
            subheading=""
        >
            {props.children}
        </DashboardLayout>
    )
}

const mapStateToProps = state => ({
    accessLevel: state.loggedUser.accessLevel,
    currentLoggedUser:state.loggedUser,
    loggedUser : state.loggedUser.globalPermissions
})

export default connect(mapStateToProps)(OperationsLayout);